(function () {
  function ensureDataLayer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  function ensureProductObject() {
    if (typeof window.PGdataLayer === 'undefined') {
      window.PGdataLayer = {};
    }
    if (!window.PGdataLayer.product) {
      window.PGdataLayer.product = {};
    }
    return window.PGdataLayer.product;
  }

  function updateProductFromVariant(variant) {
    if (!variant) {
      return;
    }

    var product = ensureProductObject();
    product.gtin = variant.sku || '';
    product.upc = variant.barcode || '';
  }

  function getProductName(el) {
    if (!el) {
      return '';
    }

    var named = el.closest('[data-pg-product-name]');
    if (named && named.getAttribute('data-pg-product-name')) {
      return named.getAttribute('data-pg-product-name');
    }

    if (window.PGdataLayer && window.PGdataLayer.product && window.PGdataLayer.product.name) {
      return window.PGdataLayer.product.name;
    }

    return '';
  }

  function getRetailerName(el) {
    if (!el) {
      return '';
    }

    var explicit = el.getAttribute('data-retailer-name') || el.getAttribute('data-retailer');
    if (explicit) {
      return explicit;
    }

    var aria = el.getAttribute('aria-label');
    if (aria) {
      return aria;
    }

    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (text) {
      return text;
    }

    var img = el.querySelector && el.querySelector('img[alt]');
    if (img && img.getAttribute('alt')) {
      return img.getAttribute('alt');
    }

    return 'Retailer';
  }

  function pushBuyNowEvent(productName, retailerName) {
    ensureDataLayer().push({
      event: 'event_buy_now',
      event_category: 'event_bin_action',
      event_action: 'event_buy_now',
      event_label: productName || '',
      retailer_name: retailerName || '',
    });
  }

  function pushSocialExitEvent(platform) {
    ensureDataLayer().push({
      event: 'social_media_link_click',
      category: 'event_social_action',
      action: 'event_socialmedia_exit',
      label: platform || '',
      value: 0,
    });
  }

  function pushCouponIntentEvent() {
    ensureDataLayer().push({
      event: 'event_coupon_request',
      category: 'event_coupon_action',
      action: 'event_coupon_request',
      label: '',
      value: 0,
    });
  }

  function pushWhereToBuyInteraction(interactionType) {
    ensureDataLayer().push({
      event: 'where_to_buy_interaction',
      interaction_type: interactionType || 'button clicked',
      interaction_description: 'clicked',
    });
  }

  function clearEcommerce() {
    ensureDataLayer().push({ ecommerce: null });
  }

  function pushSelectItem(itemData) {
    if (!itemData) {
      return;
    }

    clearEcommerce();
    ensureDataLayer().push({
      event: 'select_item',
      ecommerce: {
        currency: itemData.currency || '',
        item_list_id: itemData.item_list_id || '',
        item_list_name: itemData.item_list_name || '',
        items: [
          {
            item_id: itemData.item_id || '',
            item_name: itemData.item_name || '',
            item_brand:
              itemData.item_brand ||
              (window.PGdataLayer &&
                window.PGdataLayer.GTM &&
                window.PGdataLayer.GTM.SiteBrand) ||
              'Pantene',
            item_category: itemData.item_category || '',
            price: itemData.price || 0,
            index: itemData.index || 0,
            quantity: 1,
          },
        ],
      },
    });
  }

  function parseTrackItem(el) {
    if (!el) {
      return null;
    }

    var raw = el.getAttribute('data-track-item');
    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function isRetailerClickTarget(el) {
    if (!el || el.nodeType !== 1) {
      return null;
    }

    if (el.matches('[data-retailer-link]')) {
      return el;
    }

    var marked = el.closest('[data-retailer-link]');
    if (marked) {
      return marked;
    }

    // Wayvia / PriceSpider injected retailer links inside widgets
    var wayviaLink = el.closest(
      '.ps-widget a[href], .ps-lightbox a[href], .sc-btn-retailer-wrapper a[href], div[id^="sc-rd"] a[href]'
    );
    if (wayviaLink) {
      return wayviaLink;
    }

    return null;
  }

  document.addEventListener('product:variant-change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    updateProductFromVariant(variant);
  });

  document.addEventListener(
    'click',
    function (evt) {
      var target = evt.target;
      if (!target || !target.closest) {
        return;
      }

      var socialLink = target.closest('[data-social-link]');
      if (socialLink) {
        pushSocialExitEvent(socialLink.getAttribute('data-social-platform'));
      }

      var couponLink = target.closest('[data-coupon-link]');
      if (couponLink) {
        pushCouponIntentEvent();
      }

      var whereToBuy = target.closest('[data-click-type="where_to_buy"]');
      if (whereToBuy) {
        pushWhereToBuyInteraction('button clicked');
      }

      var retailerTarget = isRetailerClickTarget(target);
      if (retailerTarget) {
        var productName = getProductName(retailerTarget);
        var retailerName = getRetailerName(retailerTarget);
        pushBuyNowEvent(productName, retailerName);

        // Retailer selection inside WTB popup / widget
        if (!whereToBuy && retailerTarget.closest('.ps-lightbox, .ps-widget, div[id^="sc-rd"], .sc-btn-retailer-wrapper')) {
          pushWhereToBuyInteraction('select_product');
        }
      }

      var productItem = target.closest('[data-track-item]');
      if (productItem) {
        var link = target.closest('a[href]');
        if (link && productItem.contains(link)) {
          pushSelectItem(parseTrackItem(productItem));
        }
      }
    },
    true
  );
})();
